// import { httpRegisterToOur } from "../api/apiCalls";
import Message, { ConsumerMessage } from "./Message";
import WebsocketEventer from "./WebsocketEventer";

export const BIGGEST_CONSUMER_ID = 998;

export async function registerWSClient(
  ws: WebsocketEventer,
  event: string,
  userid: string
) {
  const register: Message = {
    job: "CON_JOIN",
    kind: "CONTROL",
    body: {
      consumer: { type: "USER", userId: userid },
      eventId: event,
    } as ConsumerMessage,
  };
  console.debug("sending", register);

  ws.send(register);
  try {
    // await httpRegisterToOur(register);
  } catch (error) {}
}

export async function leaveWsChannel(
  ws: WebsocketEventer,
  event: string,
  userid: string
) {
  const leave: Message = {
    job: "CON_LEAVE",
    kind: "CONTROL",
    body: {
      consumer: { type: "USER", userId: userid },
      eventId: event,
    } as ConsumerMessage,
  };

  ws.send(leave);
  try {
    // await httpRegisterToOur(leave);
  } catch (error) {}
}

export function createWsClient(hostname: string, port?: string) {
  let server: string = hostname;
  if (port !== undefined) {
    server = server + ":" + port;
  }
  const ws = new WebSocket(server);
  console.debug("connecting to ", server);

  return ws;
}
